import React, {Component} from 'react';
import moment from 'moment';

const timeFormat = 'YYYY年MM月DD日 HH:mm:ss';

class RealTime extends Component{
    timer = null;

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.timer = setInterval(this.refresh, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    refresh = () => this.setState({});

    render(){
        return <span>{moment().format(timeFormat)}</span>;
    }
}

export default RealTime;